import React from "react";
import "./TruckImages.css";

import one from "../images/one.jpeg";
import two from "../images/two.jpeg";
import three from "../images/three.jpeg";

export default function TruckImages() {
  const images = [
    { src: one, caption: "Safety-first transport by our drivers" },
    { src: two, caption: "Reliable drivers ready for every job" },
    { src: three, caption: "Delivering comfort and satisfaction (precious goods) to our clients" }
  ];

  return (
    <div className="truck-images">
      {images.map((item, index) => ( 
        <div className="image-card" key={index}>
          <img src={item.src} alt="truck" />
          <p className="caption">{item.caption}</p>
        </div>
      ))}
    </div>
  );
}